import { DatePipe } from '@angular/common';
import { Pipe, PipeTransform } from '@angular/core';

@Pipe({
    name: 'customDate',
    standalone: false
})
export class CustomDatePipe extends DatePipe implements PipeTransform {
    transform(value: any, format?: any): any {
        value = value.replace(/\s/g, "T");
        if (!format) {
            format = 'dd/MM/YYYY';
        }
        return super.transform(value, format);
    }
}
